<script>
export default {
  name: 'Gauge',
  props: {
    score: {
      type: Number,
      required: true
    },
    label1: {
      type: String,
      required: true
    },
    label2: {
      type: String,
      required: true
    },
    equalDivision: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    angle() {
      return (this.score / 100) * 180; // Default behavior based on score
    },
    sliceStyles() {
      if (this.equalDivision) {
        return [
          { 'border-bottom-color': '#E84C3D' },
          { 'border-bottom-color': '#E84C3D' },
          { 'border-bottom-color': '#f1c40f', top: '0px', left: '-108px', 'border-left-width': '70px', 'border-right-width': '70px', 'z-index': 1 },
          { 'border-bottom-color': '#1eaa59' },
          { 'border-bottom-color': '#1eaa59' }
        ];
      }
      return [
        { 'border-bottom-color': '#E84C3D' },
        { 'border-bottom-color': '#E84C3D' },
        { 'border-bottom-color': '#E84C3D' },
        { 'border-bottom-color': '#f1c40f' },
        { 'border-bottom-color': '#1eaa59' }
      ];
    }
  }
};
</script>

<template>
  <div class="wrapper">
    <div class="gauge">
      <div class="slice-colors">
        <div v-for="(style, index) in sliceStyles" :key="index" :class="['st', 'slice-item']" :style="style" ></div>
      </div>
      <div class="needle" :style="{ transform: `rotate(${angle}deg)` }"></div>
      <div class="gauge-center">
        <span>{{ score }}</span>
      </div>
    </div>
    <div class="gauge-text my-3">
      <p style="text-align: center;"><b>{{ label1 }}</b></p>
      <p>{{ label2 }}</p>
    </div>
  </div>
</template>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 3rem;
}

.gauge {
  font-family: Arial, Helvetica, sans-serif;
  background: #e7e7e7;
  box-shadow: 0 0 0 6px rgba(255, 255, 255, .09), 0 0 35px 5px rgba(255, 255, 255, .29);
  width: 200px;
  height: 100px;
  border-radius: 100px 100px 0 0;
  position: relative;
  overflow: hidden;
}

.gauge-center {
  content: '';
  width: 60%;
  height: 60%;
  background: #15222E;
  border-radius: 100px 100px 0 0;
  position: absolute;
  box-shadow: 0 -13px 15px -10px rgba(0, 0, 0, .28);
  right: 21%;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 1.5em;
  z-index: 2;
}

.needle {
  width: 78px;
  height: 7px;
  background: #15222E;
  border-bottom-left-radius: 100%;
  border-bottom-right-radius: 5px;
  border-top-left-radius: 100%;
  border-top-right-radius: 5px;
  position: absolute;
  bottom: 4px;
  left: 20px;
  transform-origin: 100% 4px;
  z-index: 2;
}

.slice-colors .st {
  position: absolute;
  bottom: 0;
  width: 73px;
  height: 0;
  border-bottom: 80px solid #000;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
}

.slice-item.red {
  border-bottom-color: #E84C3D;
}

.slice-item.yellow {
  border-bottom-color: #f1c40f;
}

.slice-item.green {
  border-bottom-color: #1eaa59;
}

.slice-item {
  &:nth-child(1) { left: -2px; }
  &:nth-child(2) { transform: rotate(135deg); transform-origin: right; top: 12px; left: -35px; }
  &:nth-child(3) { transform: rotate(175deg); transform-origin: right; top: 0px; left: -35px; border-bottom-width: 90px; border-left-width: 45px; border-right-width: 45px; width: 18px; }
  &:nth-child(4) { transform: rotate(206deg); transform-origin: right; top: -7px; right: 89px; }
  &:nth-child(5) { transform: rotate(245deg); transform-origin: right; top: 8px; right: 52px; }
}

.gauge-text {
  max-width: 200px; /* Ensure the text does not exceed the gauge's width */
  width: 100%;
}
</style>
